import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "list-group list-group-flush" }
const _hoisted_2 = { class: "row align-items-start g-2" }
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "fw-bold"
}

import { BulletListItem, BulletListIconStyle } from '@/guiide/ts/components/bulletListIconStyle';


export default /*@__PURE__*/_defineComponent({
  __name: 'BulletPointList',
  props: {
    items: { type: Array<BulletListItem>, required: true },
    iconStyle: { default: BulletListIconStyle.Bullet, required: false },
    showDivider: { default: true, required: false }
},
  setup(__props) {

const props = __props

function getBulletStyle(): string {
    switch (props.iconStyle) {
        case BulletListIconStyle.Bullet:
            return "bullet-disc";
        case BulletListIconStyle.Tick:
            return "bi-check text-success";
        case BulletListIconStyle.Cross:
            return "bi-x text-danger";
        default:
            return "bullet-disc";
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
      return (_openBlock(), _createElementBlock("li", {
        key: i,
        class: "list-group-item px-0 border-0"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("i", {
              class: _normalizeClass(["bi fs-4 bullet-icon", getBulletStyle()])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (item.subtitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.subtitle), 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(item.text), 1)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})